var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart"},[_c('highcharts',{key:("radar_" + (_vm.$i18n.locale) + "_" + _vm.darkMode + "_" + (_vm.$vuetify.breakpoint.mdAndUp)),staticClass:"hc",attrs:{"id":"percentileRadarChart","options":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }